import { PTContentType } from './peppertype'

export enum EditorApps {
  CONTENT_GAP_REPORT = 'content-gap-report',
  CONTENT_RESEARCH_REPORT = 'crr',
  CONTENT_AUDIT = 'audit',
  AI_WRITING = 'ai_writing',
  AI_DETECTION = 'ai_detection',
  READABILITY = 'readability',
  INTERLINKING = 'interlinking'
}

export type EditorTokenPayload = {
  exp: number
  iat: number
  // encrypted data not used in the frontend
  payload: string
}

export type ContentGapEditorAppMetadata = {
  id: string
}

export type CRREditorAppMetadata = {
  id: string
  topic_id: string
}

export type AIWritingEditorAppMetadata = {
  is_domain_deleted: boolean
  content_types?: PTContentType[]
} & DomainConfig

export type ContentAuditEditorAppMetadata = {
  id: string
  settings: AuditReportSettings
}

export type AIDetectionAppMetadata = {
  id: string
  can_generate_report: boolean
  max_usage_count: number
  usage_count: number
}

export type DomainConfig = {
  country_code: string
  domain_id: string
  domain_url: string
}

export type InterlinkingSuggestionItem = {
  id: number
  associated_links: {
    distance: number
    link: string
    title: string
  }[]
  sentence: string
}

export type TitleGenerationMetadata = {
  content: string
}

export enum StatusTypes {
  FAIL_STATUS = 'failure',
  SUCCESS_STATUS = 'success',
  PARTIAL_SUCCESS = 'partial_success',
  IN_PROGRESS = 'in_progress'
}
